import styled from '@emotion/styled';

export const StepHeadline = styled.h4({
    color: '#040f16',
    fontFamily: 'FT Regola Neue',
    fontSize: '1.5rem',
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: '-0.03rem',
    lineHeight: '2rem',
    margin: 0,
    padding: 0,
});
